<template>
  <div class="con_bk">
    <header>
      <p>
        <img src="../assets/logo.png" />
      </p>
    </header>
    <section>
      <div class="login">
        <div class="login_left">
          <div class="login_left_con">
            <h1>登 录</h1>
            <p class="username">账号</p>
            <p class="usernameInput">
              <input type="text" placeholder="请输入账号名" v-model="username" />
            </p>
            <p class="password">密码</p>
            <p class="passwordInput">
              <input type="password" placeholder="请输入密码" v-model="password" />
            </p>
            <p class="loginbtn">
              <el-button
                type="primary"
                round
                v-on:click="login()"
                v-loading.fullscreen.lock="fullscreenLoading"
              >登录</el-button>
            </p>
            <p class="loginCheck">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
            </p>
          </div>
        </div>
        <div class="login_right">
          <p class="p_tit mt75">企业管理的首选方案</p>
          <p class="p_tit mt10">
            <label>超级眼</label>监控
          </p>
          <p class="p_pic">
            <img src="../assets/login_ui.png" />
          </p>
          <p class="p_btn mt65">超级眼是一款专业的电脑监控软件，采用尖端监控技术</p>
          <p class="p_btn mt10">研发而成，便捷，安全，稳定。</p>
        </div>
      </div>
    </section>
    <footer>
      <p>【超级眼官网：www.360mon.cn】超级眼电脑监控软件是深圳市超时代软件有限公司开发的局域网监控软件, 可以进行电脑屏幕监控,聊天记录监控等一系列监控</p>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: true,
      username: "",
      password: "",
      fullscreenLoading: false,
      timer: 0
    };
  },
  created() {
    if (localStorage.getItem("username")) {
      this.username = localStorage.getItem("username");
      this.password = localStorage.getItem("password");
    }
  },
  methods: {
    login() {
      if (this.checked) {
        localStorage.setItem("username", this.username);
        localStorage.setItem("password", this.password);
      } else {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var crypto = require("crypto");
      let json = {
        user: this.username,
        pwd: crypto
          .createHash("md5")
          .update(this.password)
          .digest("hex"),
        peerId: "webser::" + this.username,
        ip: "127.0.0.1",
        mac: "webser::" + this.username,
        type: 2
      };
      //在使用地方调用
      if (this.global.ws.readyState == 1) {
        this.global.ws.send(JSON.stringify(json));
      } else {
        this.global.ws.onopen = () => {
          //绑定连接事件
          this.global.ws.send(JSON.stringify(json));
        };
      }
      this.global.ws.onmessage = params => {
        let data = JSON.parse(params.data);
        console.log(data);
        let mac = "";
        if (data.code == 0) {
          if (data.data == "") {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error"
            });
            loading.close();
          } else {
            for (let i = 0; i < data.data.list.server.length; i++) {
              if (
                data.data.list.server[i].is_online == 1 &&
                data.data.list.server[i].mac == "21-2B-F8-99-1E-9A-04-C8"
              ) {
                mac = data.data.list.server[i].mac;
                break;
              }
            }
            var save = {
              oauth_token: data.data.auth_token,
              user_domain: data.data.user_domain,
              user_name: data.data.owner,
              datas: JSON.stringify(data.data),
              dataGroup: JSON.stringify(data.data.list),
              mac: mac
            };
            this.$store.commit("loginsave", save);
            loading.close();
            this.$router.replace("/hyjm");
          }
        } else {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "error"
          });
          loading.close();
        }
      };
    },
    cscl() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$message({
        showClose: true,
        message: "连接超时,请重新刷新页面。",
        type: "error"
      });
      loading.close();
      clearInterval(this.timer);
    }
  }
};
</script>
<style scoped>
.con_bk {
  background-image: linear-gradient(
      to top right,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    linear-gradient(rgba(255, 255, 255, 0.5) 100%, transparent),
    url("../assets/bk_wz.jpg");
  position: fixed;
  width: 100%;
  background-size: 100% 100%;
  height: calc(100%);
  overflow: auto;
  min-height: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
header {
  height: 120px;
}
header p {
  text-align: left;
  margin-left: 57px;
  padding-top: 52px;
}
section {
  height: 574px;
  position: relative;
}
.login {
  position: absolute;
  left: 50%;
  margin-top: 50px;
  margin-left: -476px;
  width: 952px;
  height: 574px;
  display: flex;
  border-radius: 30px;
}
.login .login_left {
  width: calc(952px - 475px);
  text-align: center;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background: #ffffff;
}
.login .login_left .login_left_con {
  width: 270px;
  margin: 0 auto;
}
.login .login_left h1 {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(92, 159, 236, 1);
  margin-top: 70px;
}
.login .login_left .username {
  margin-top: 60px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(161, 161, 161, 1);
}
.login .login_left .usernameInput {
  margin-top: 12px;
}
.login .login_left .usernameInput input[type="text"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid #bebebe;
  line-height: 30px;
  text-indent: 5px;
  font-size: 16px;
}
.login .login_left .password {
  margin-top: 30px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(161, 161, 161, 1);
}
.login .login_left .passwordInput {
  margin-top: 12px;
}
.login .login_left .passwordInput input[type="password"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid #bebebe;
  line-height: 30px;
  text-indent: 5px;
  font-size: 16px;
}
.login .login_left .loginbtn {
  margin-top: 35px;
}
.login .login_left .loginbtn /deep/.el-button.is-round {
  padding: 15px 53px;
  border-radius: 50px;
}
.login .login_left .loginCheck {
  margin-top: 22px;
}
.login .login_right {
  width: 475px;
  text-align: center;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  background: -webkit-radial-gradient(50% 50%, #289cfe, #297fff);
}
.login .login_right p.p_tit {
  font-size: 23px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.login .login_right p.p_tit label {
  color: #f5d66e;
}
.login .login_right p.mt65 {
  margin-top: 65px;
}
.login .login_right p.mt75 {
  margin-top: 75px;
}
.login .login_right p.mt10 {
  margin-top: 5px;
}
.login .login_right p.p_pic {
  margin-top: 28px;
}
.login .login_right p.p_btn {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
footer {
  margin-top: 100px;
  height: 100px;
}
footer p {
  padding-top: 30px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(122, 122, 122, 1);
}
</style>